/*
 * @Description: 页面说明 路由
 * @Version: 版本号
 * @Author: chuzhangyi
 * @Date: 2023-04-10 09:33:23
 * @LastEditors: 最后一次编辑说明
 * @LastEditTime: 2025-10-17 10:14:14
 * @FilePath: \dingtalk_examinee:\LBB\wechat_business\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import meta from '../router/pagetitle';
import store from '@/store'
import { getQueryString, isWeiXin, isWxWork, isMiniProgram } from '@/utils/index.js';

import {
  setWxConfig,
  setWxAagentConfig,
  getSalesInfo,
  getContext,
  getCode,
  getCurExternalContact,
  getCurExternalChat
} from '@/utils/baseConfig.js';
import { getSelectOptions } from "../utils/crm.user";
import { isPartnerRoute, isPartnerWriteRoute } from '@/utils/partner/constants';
import { isPartnerWxWorkMode } from '@/utils/partner/auth';
import { Toast } from 'vant';

let isFirst = true; // 首次进入
let count = 0;
Vue.use(Router);

// 不需要匹配可选参数 :id? 的路由名称列表
const noParamRoutes = ['offers-billingScreenshot'];

const configTypes = {
  '1000018': 1, // 工单
  '1000026': 2, // 报价工具
  '1000029': 3, // 消息
  '1000031': 4, // 绩效
  '1000039': 5, // 供应商
  '1000041': 6, // 测试
  '1000042': 7, // 基差管理
  '1000044': 8, // 豆粕发货管理
  '1000045': 9, // 玉米发货管理
  '1000028': 10, // 测试专用
  '1000046': 11, // 玉米报价管理
  '1000048': 12, // 豆粕限量提货管理
  '1000051': 13, // 客户详情
  '1000052': 14, // 客户拜访
}; // 自建应用配置
// 15 CRM 16 烘干塔 17 油厂 18 预混料报价 19 预混料发货管理 20 采购管理 21 豆粕寄售报价管理
const testATypeRX = [101, 102]  // 测试（睿兴）
const testATypeHY = [201, 202, 203, 204]  // 测试（慧耀科技）

function isCustomerInspectionRoute(path) {
  const href = window.location.href || ''
  return String(path || '').includes('visit-inspectionCustomer') || href.includes('visit-inspectionCustomer')
}

/**
 * 从 import.meta.glob 的 key 解析路由 name（需与旧逻辑一致）。
 * Vite 返回的 key 常为绝对路径，不能只依赖 replace('@/views/modules')。
 */
function globKeyToPathName(globKey) {
  const normalized = String(globKey).replace(/\\/g, '/')
  const m = normalized.match(/views\/modules\/(.+)\.vue$/i)
  if (!m) {
    return ''
  }
  const rel = m[1]
  const parts = rel.split('/').filter(Boolean)
  const len = parts.length
  if (!len) {
    return ''
  }
  const lastSeg = parts[len - 1]
  if (lastSeg === 'index') {
    return len >= 2 ? parts[len - 2] : ''
  }
  if (len === 1) {
    return lastSeg
  }
  return `${parts[len - 2]}-${lastSeg}`
}

// 设置路由
function setAllrouter() {
  // 使用 Vite 的动态导入替换 require.context
  const modules = import.meta.glob('@/views/modules/**/*.vue');
  let routerList = [];
  let index = 0;

  Object.keys(modules).forEach((path) => {
    let pathName = globKeyToPathName(path)
    if (!pathName) {
      let pageName = path.replace('@/views/modules', '');
      let pageUrl = pageName.split('/');
      let len = pageUrl.length;

      if (pageUrl[len - 1].split('.')[0] == 'index') {
        pathName = pageUrl[len - 2].split('.')[0] == '' ? '' : pageUrl[len - 2];
      } else {
        pathName = pageUrl[len - 2].split('.')[0] == '' ? pageUrl[len - 1].split('.')[0] : `${pageUrl[len - 2]}-${pageUrl[len - 1].split('.')[0]}`;
      }
    }
    if (!pathName) {
      console.warn('[router] 无法从路径生成路由名，已跳过：', path)
      return
    }

    const basePath = `/${pathName}`;
    const routePath = noParamRoutes.includes(pathName) ? basePath : `${basePath}/:id?`;

    routerList[index] = {
      name: pathName,
      path: routePath,
      component: modules[path],
      props: (route) => ({
        query: route.query.q
      }),
      meta: {
        title: meta[pathName] || store.state.title
      }
    }
    index++;
  });

  // console.log(routerList)
  return routerList;
}

// 进入页面前初始化数据
const beforInitDom = function (toPath) {
  return new Promise(async (resolve, reject) => {
    const path = toPath || window.location.pathname
    if (isPartnerRoute(path)) {
      // 友商页：外部微信 / 友商 OAuth 回跳 / 已登录友商 → 不走业务员企微授权，避免连环跳转
      const hasPartnerOAuth =
        !!getQueryString('openid') ||
        !!localStorage.getItem('partnerUserInfo') ||
        !!sessionStorage.getItem('partnerUserInfo') ||
        getQueryString('oauthFail') === '1'
      if (!isWxWork() || hasPartnerOAuth) {
        resolve()
        return
      }
    }
    // 分享给客户的巡场报告：客户在微信/企微打开，不能走业务员 getUserByCode
    if (isCustomerInspectionRoute(path)) {
      if (!sessionStorage.getItem('pageType')) {
        const type = getQueryString('agentidtype') || 1;
        sessionStorage.setItem('pageType', type);
      }
      resolve()
      return
    }
    if (isWeiXin()) {

      if(getQueryString('userIdCode') && getQueryString('hidetab') == 1 && getQueryString('active') == 4 && location.href.includes('/portrait-customerProfile')){
        resolve()
        return
      }

      // 区分8：豆粕/9：玉米发货管理
      if (!sessionStorage.getItem('pageType')) {
        // agentid 应用id（需要在上面configTypes 中声明）  agentidtype 应用id类型   都是用来调用企微api的依据（有一个即可）
        let type = configTypes[getQueryString('agentid')] || getQueryString('agentidtype') || 1;
        sessionStorage.setItem('pageType', type);
        
        // if ( getQueryString('unionid') && getQueryString('miniappBrand')) {
        //   sessionStorage.setItem('pageType', '23');
        // }

        console.log('type', 'type', type);
        let appId = 'wwc6ccf90e495eda05';// 正式
        if (testATypeRX.includes(+type)) {
          appId = 'ww773affc0347f9c1b';// 测试 睿兴
        } else if (testATypeHY.includes(+type)) {
          appId = 'ww9e55fc846ab4897a';// 测试 慧耀
        }
        sessionStorage.setItem('appId', appId);
      }
      // 是否有业务员userid
      console.log(store.state.salesInfo.userId)
      console.log(store.state)
      if (!store.state.salesInfo.userId) {

        if(getQueryString('salesUserId')){

          const { code, data } = await $http.post('querySalesmanInfo', {
            qwUserId: getQueryString('salesUserId'),
          })
          if(code == 200){
            store.dispatch('setSalesInfo', {
              ...data,
              userId: data.qwUserId,
              name: data.userName,
              sysUserId: data.sysUserId,
              jobNumber: data.jobNumber,
            });
            window.tracker && window.tracker.updateUser({
              userid: data.qwUserId,
              name: data.userName,
            });
            await initConfig();
            resolve();
          }
        }else{
          let authorizationCode = getQueryString('code');
          if (authorizationCode) {
            let pageType = sessionStorage.getItem('pageType');

            await getSalesInfo(authorizationCode, pageType);// 获取业务员信息
            await initConfig();
            // await setWxConfig();// 获取企微配置
            // await setWxAagentConfig(); // 获取企业微信agentConfig配置信息
            // await getContext();// 获取当前入口环境（成功后获取当前群id或客户信息）
            // if (store.state.entry == 'single_chat_tools') {
            //   await getCurExternalContact(); // 获取当前聊天客户信息
            // } else if (store.state.entry == 'group_chat_tools') {
            //   await getCurExternalChat(); // 获取群id
            // };
            resolve();
          } else {
            getCode();
          }
        }

      } else {
        if (import.meta.env.MODE === 'production') {
          window.tracker.updateUser({
            userid: store.state.salesInfo.userId,
            userName: store.state.salesInfo.name,
          });
        }
        await initConfig();
        resolve();
      }
    } else {
      // 钉钉预览报价
      if (getQueryString('source') == 'dingding') {
        store.dispatch('setUserInfo', {
          userId: getQueryString('userId'),
          userIdStr: decodeURIComponent(getQueryString('userIdCode')),
        });
        resolve();
      }
      // 本地调试使用数据
      else if (!store.state.salesInfo.userId && (import.meta.env.MODE !== 'production' || getQueryString('lbbSource') == 'test')) {
        let type = configTypes[getQueryString('agentid')] || getQueryString('agentidtype') || 1;
        if (!sessionStorage.getItem('pageType')) {
          sessionStorage.setItem('pageType', type);
        }
        const res = {
          "sales_name": "业务员",
          "sales_qw_user_id": "ZaJPHW8y2JiDVxYNOVKFMg==",
          "userId": "liyongda",
          "sysUserName": "范宜江",
          "sysUserId": 221
          // "sales_name": "业务员",
          // "sales_qw_user_id": "wrO9kgFwAA57pMMhaOg1GLgB05duWO8g",
          // "userId": getQueryString('testUserId') || "liyiming",
          // "sysUserName": "李熠铭",
          // "sysUserId": 74,
          // "sales_name": "业务员",
          // "sales_qw_user_id": "wrO9kgFwAA57pMMhaOg1GLgB05duWO8g",
          // "userId": getQueryString('testUserId') || "YangJie",
          // "sysUserName": "赵杨杰",
          // "sysUserId": 78,
          // "sales_name": "业务员",
          // "sales_qw_user_id": "wrO9kgFwAA57pMMhaOg1GLgB05duWO8g",
          // "userId": getQueryString('testUserId') || "zhengcaifa",
          // "sysUserName": "郑才发",
          // "sysUserId": 123484,
          // "sales_name": "业务员",
          // "sales_qw_user_id": "wrO9kgFwAA57pMMhaOg1GLgB05duWO8g",
          // "userId": getQueryString('testUserId') || "liyongda",
          // "sysUserName": "李永达",
          // "sysUserId": 74
        }; // 业务员
        store.dispatch('setSalesInfo', { userId: res.userId, userIdTm: res.sales_qw_user_id, name: res.sysUserName || res.sales_name, sysUserId: res.sysUserId, sysUserName: res.sysUserName, });
        const id = 'wrO9kgFwAAqSMUpazAqDawjaSFyWRwOQ';// 群id
        // const id = 'wrO9kgFwAA57pMMhaOg1GLgB05duWO8g';//pre
        // debugger
        store.dispatch('setChatId', id);
        // const ENTRY = 'group_chat_tools'; // 入口环境 group_chat_tools：群；single_chat_tools：单聊
        const ENTRY = 'single_chat_tools'; // 入口环境 group_chat_tools：群；single_chat_tools：单聊
        store.dispatch('setEntry', ENTRY);
        if (ENTRY == 'single_chat_tools') {
          // 当前客户信息
          // let userId = 'wmO9kgFwAAvut6-1a6l_cav9HH_mt_EA';
          let userId = 'wmO9kgFwAAvEcxkQ_0RzC0JtwOcE8ksw';
          const { code, data = {} } = await $http.get('getExternalContactByWxUserId', { params: { externalUserId: userId, isCancel: 1 } });
          if (code == 200) {
            store.dispatch('setCurExternalContact', { ...data, userId });
          } else {
            store.dispatch('setCurExternalContact', { userId });
          }
        }
        resolve()
      } else {
        resolve()
      }
    }
  })
};
const initConfig = async function () {
  console.log('initConfig');
  await setWxAagentConfig(); // 获取企业微信agentConfig配置信息
  console.log('initConfig1');
  await getContext();// 获取当前入口环境（成功后获取当前群id或客户信息）
  // if (store.state.entry == 'single_chat_tools') {
  //   await getCurExternalContact(); // 获取当前聊天客户信息
  // } else if (store.state.entry == 'group_chat_tools') {
  //   await getCurExternalChat(); // 获取群id
  // }
  // ;
  console.log('initConfig2');
}
let routerList = setAllrouter();
log(routerList);
let router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/index'
  }, {
    path: '/404',
    name: "404",
    component: () => import('@/views/404')
  }, {
    path: '/tanma',
    name: "tanma",
    component: () => import('@/views/tanma')
  }, {
    path: '/index',
    name: "index",
    component: () => import('@/views/index')
  }],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      if (savedPosition) {
        setTimeout(() => {
          resolve(savedPosition)
        }, 350)
      } else {
        // 页面滚动高度为0
        resolve({
          x: 0,
          y: 0
        });
      }
    })
  }
});
routerList.forEach(el => {
  router.addRoute(el);
});
// 通配必须注册在所有动态模块路由之后，否则 /xxx 会先命中 * 直接进 404（例如 /location-help）
router.addRoute({
  path: '*',
  redirect: {
    name: '404'
  }
});
router.beforeEach(async (to, from, next) => {

  try {
    if (isFirst) {
      // console.log(1212, 'beforInitDom');
      await beforInitDom(to.path);
      try {
        await store.dispatch('setTeamUserList')
        await store.dispatch('setWhiteStoreList')
        await store.dispatch('setStaffInfo')
        getSelectOptions('CHICKEN_SHED_NO')
        getSelectOptions('CHICKEN_BREED')
        getSelectOptions('PREMIX_BRAND')
        getSelectOptions('BREEDING_TYPE')
        getSelectOptions('USER_LEVEL')
      } catch (e) {

      }

      isFirst = false;
    }

    if (isPartnerRoute(to.path) && isPartnerWxWorkMode(store) && isPartnerWriteRoute(to)) {
      Toast('当前为只读模式，无法操作')
      next({ name: 'partner-customerList', replace: true })
      return
    }

    next();
  } catch (error) {
    next();
  }
});
router.afterEach(async (to, from) => {
  store.dispatch('setTitle', meta[to.name] || '粮巴巴');
  const isCustomerReport = isCustomerInspectionRoute(to.path) || to.name === 'visit-inspectionCustomer';
  if (!isPartnerRoute(to.path) && !isCustomerReport) {
    await setWxAagentConfig()
  }
  window.document.title = meta[to.name] || store.state.title;
})
export default router;
